import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import axios from 'axios';
import VueSocketIO from 'vue-socket.io';

import 'vant/es/dialog/style';
import 'vant/es/toast/style';
import 'animate.css';

import RouterUtil from '@/utils/RouterUtil';
import SessionUtil from '@/utils/SessionUtil';

const app = createApp(App);
app.use(router);
app.mount('#app');

axios.defaults.withCredentials = true;
axios.interceptors.request.use(function(config) {
  config.headers.set('access-token', SessionUtil.getUserToken());
  config.headers.set('Cache-Control', 'no-cache');
  return config;
});
axios.interceptors.response.use(function(response) {
  if (response.data?.code === 401) {
    SessionUtil.clear();
    window.location.href = '/login'; // 跳转到登录页面
  }
  return response;
}, function(error) {
  // 响应错误处理
  if (error.response && error.response.status === 401) {
    SessionUtil.clear();
    window.location.href = '/login'; // 跳转到登录页面
  }
  return Promise.reject(error);
});

RouterUtil.setRouter(router);

// app.use(new VueSocketIO({
//     debug: true,
//     connection: 'ws://127.0.0.1:9092',
// }));

app.directive('height-animate', {
  updated(el) {
    let height = el.scrollHeight;
    el.style.setProperty('--bottom-wrap-max-height', height + 'px');
  }
});
